import * as React from 'react';
import { FC } from 'react';

import { PullToReload, PullToReloadContent } from 'components/pull-to-reload';

import { LoyaltyLoadingAnimation, LoyaltyPullDownLoader } from '../loyalty-lottie-animations';

interface ILoyaltyPullToReload {
  onRefresh(): Promise<any>;
  enabled?: boolean;
}

const LoyaltyPullToReload: FC<ILoyaltyPullToReload> = ({ onRefresh, children, enabled }) => {
  return (
    <PullToReload
      pullDownThreshold={100}
      triggerHeight={500}
      startInvisible
      enabled={enabled}
      onRefresh={onRefresh}
      pullDownContent={
        <PullToReloadContent action="pullingDown" animationData={LoyaltyPullDownLoader} />
      }
      releaseContent={
        <PullToReloadContent action="releasing" animationData={LoyaltyPullDownLoader} />
      }
      refreshContent={
        <PullToReloadContent action="refreshing" animationData={LoyaltyLoadingAnimation} />
      }
    >
      {children}
    </PullToReload>
  );
};

export default LoyaltyPullToReload;
